import { createFileRoute, Outlet } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { PortalRouteShell } from "@/components/portal/portal-route-shell";
import { loadPortalRouteShell } from "@/components/portal/portal-route-shell.server";
import { sanitizeReturnTo } from "@/lib/portal-auth-shared";

const loadShell = createServerFn({ method: "GET" })
  .validator((input: string) => sanitizeReturnTo(input))
  .handler(({ data }) => loadPortalRouteShell({ allowPublicPreview: true, nextPath: data }));

export const Route = createFileRoute("/_preview")({
  loader: ({ location }) => loadShell({ data: location.href }),
  component: PreviewLayout,
});

function PreviewLayout() {
  return <PortalRouteShell data={Route.useLoaderData()}><Outlet /></PortalRouteShell>;
}
